import { Box, Button } from "@mui/material";
import React, { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import UploadFileBrsr from "./UploadFileBrsr";
import FetchFilesBrsr from "./FetchFilesBrsr";

const BRSRFile = ({
  setModalUpload,
  modalupload,
  formData,
  setFormData,
  setErrors,
  errors,
  Uploadkey,
  ml,
  mt,
  removeUpload = false,
}) => {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState([]);
  const [open, setOpen] = useState(false);

  const handleUploadDocument = (key) => {
    setModalUpload((prev) => ({
      ...prev,
      [key]: true,
    }));
    setOpen(true);
  };

  return !removeUpload ? (
    <Box sx={{ ml: ml || 0, mt: mt || 0 }}>
      <Box sx={{ mt: 1 }}>
        <Button
          variant="outline"
          sx={{
            bgcolor: "transparent",
            color: "#1C486B",
            textTransform: "none",
            my: 2,
            border: "1px solid #1C486B",
            ":hover": {
              backgroundColor: "transparent",
            },
          }}
          onClick={() => handleUploadDocument(Uploadkey)}
        >
          Upload Document <AddIcon sx={{ ml: 2 }} />
        </Button>
      </Box>

      {modalupload[Uploadkey] === true && (
        <UploadFileBrsr
          {...{
            setModalUpload,
            setUploadProgress,
            setUploadedFiles,
            setErrors,
            errors,
            uploadedFiles,
            uploadProgress,
            open,
            formData,
            setFormData,
            Uploadkey,
            setOpen,
          }}
        />
      )}

      {formData?.[Uploadkey]?.length > 0 && (
        <FetchFilesBrsr
          {...{
            fileUrls: formData?.[Uploadkey],
            setUploadedFiles,
            setFormData,
            Uploadkey,
          }}
        />
      )}
    </Box>
  ) : null;
};

export default BRSRFile;
